import React from 'react';
import { TotalCosts } from '../Items/TotalCosts';
import Section from '../Section';
import { TotalClosingCostsStyled } from './TotalClosingCosts.styled';
import { ITotalClosingCosts } from '../../../ui-toolkit/cdItems/interfaces/ITotalClosingCosts';

interface ITotalCosts {
  showSeller: boolean;
  totalClosingCosts: ITotalClosingCosts;
  creditsContent?: React.ReactNode;
  hasEditPermissions?: boolean;
}

export default class TotalClosingCosts extends React.Component<ITotalCosts> {
  public render() {
    const { creditsContent, showSeller, totalClosingCosts, hasEditPermissions } = this.props;
    const { subtotals } = totalClosingCosts;
    return (
      <TotalClosingCostsStyled className="total-closing-costs">
        <Section
          data-test-id="section-j"
          name={`J. Total closing costs (${showSeller ? 'Buyer' : 'Borrower'}-paid)`}
          showSeller={showSeller}
          showLenderPaid={false}
          showNettedOut={false}
          totals={subtotals}
          hasEditPermissions={hasEditPermissions}
        >
          {creditsContent}
          <TotalCosts
            showSeller={showSeller}
            text="Closing costs subtotals (D+I)"
            buyerClosingTotal={subtotals.buyer_at_closing || 0}
            buyerBeforeTotal={subtotals.buyer_before_closing || 0}
            sellerClosingTotal={subtotals.seller_at_closing || 0}
            sellerBeforeTotal={subtotals.seller_before_closing || 0}
            othersTotal={subtotals.paid_by_others || 0}
          />
        </Section>
      </TotalClosingCostsStyled>
    );
  }
}
